import { POPULATION_TYPE } from "@/common/models";
import { SharedState } from "@/common/state";
import {
  DrillDownMenuItem,
  UseDrillDownMenu,
} from "@/components/root/drilldown-menu/drilldown-menu.state";
import { UseModal } from "@/components/root/modal";
import ManageTrustModalVue from "@/views/customize/in-motion/exposure-control/manage-trust-modal/ManageTrustModal.vue";
import { ManageTrustedModalHelper } from "@/views/customize/in-motion/exposure-control/manage-trust-modal/modal.helper";

const investigate_menu_item: DrillDownMenuItem = {
  disable: false,
  isCategory: false,
  name: "Investigate",
  icon: "Investigation",
  subItems: [],
  isPremium: false,
  action: "investigate",
};

const manage_trust_menu_item: DrillDownMenuItem = {
  disable: false,
  isCategory: false,
  name: "Manage Information Trust",
  icon: "Trust",
  subItems: [],
  isPremium: false,
  action: "manage_trust",
};

export const employee_menu = async (p: {
  item: any;
  event: MouseEvent;
  info_types: string[];
}): Promise<"idle" | "close"> => {
  const menu: DrillDownMenuItem[] = [investigate_menu_item];

  const contains_relevant_info_types =
    p.info_types.length > 1 ||
    (p.info_types.length == 1 &&
      p.info_types[0] != SharedState.default_label_id.value);

  const is_entity_type_for_trust_management = [
    POPULATION_TYPE.EMPLOYEE,
    POPULATION_TYPE.PRIVATE_EMAIL,
    POPULATION_TYPE.ORGANIZATION,
  ].includes(p.item.type);

  if (contains_relevant_info_types && is_entity_type_for_trust_management) {
    menu.push(manage_trust_menu_item);
  }

  const res = await UseDrillDownMenu().show({
    menu,
    event: p.event,
  });
  if (res.didUserSelectedAnAction) {
    if (res.actionSelected === "investigate") {
      if (SharedState.restrictions.is_restricted_app("entity_investigation")) {
        SharedState.restrictions.show_restrictions_modal(
          "app",
          "Entity Investigation"
        );
        return "idle";
      }
      SharedState.investigation.investigate({
        id: p.item.id,
        name: p.item.name,
        type: p.item.type ? p.item.type : POPULATION_TYPE.EMPLOYEE,
      });
      return "close";
    } else {
      const props = await ManageTrustedModalHelper.create_props(
        {
          ...p.item,
          type: p.item.type ? p.item.type : POPULATION_TYPE.EMPLOYEE,
        },
        p.info_types
      );
      if (SharedState.restrictions.is_restricted_app("trust_management")) {
        SharedState.restrictions.show_restrictions_modal(
          "app",
          "Trust Management"
        );
      } else {
        await UseModal().show(ManageTrustModalVue, props);
      }
      return "idle";
    }
  } else {
    return "idle";
  }
};
